import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Megaphone } from "lucide-react";
import api from "@/lib/api";

const DISMISS_KEY = "hat_promo_dismissed";

export default function PromoBanner() {
  const [promos, setPromos] = useState([]);
  const [idx, setIdx] = useState(0);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === "1");

  useEffect(() => {
    api.get("/promotions").then((r) => {
      setPromos((r.data || []).filter((p) => p.placement === "banner" || p.placement === "both"));
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (promos.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % promos.length), 5000);
    return () => clearInterval(t);
  }, [promos.length]);

  if (dismissed || promos.length === 0) return null;
  const p = promos[idx % promos.length];

  const close = () => { setDismissed(true); sessionStorage.setItem(DISMISS_KEY, "1"); };

  return (
    <div data-testid="promo-banner" className="bg-copper text-navy text-sm relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-2.5 flex items-center justify-center gap-3 text-center">
        <Megaphone size={15} className="flex-shrink-0" />
        {p.badge && <span className="bg-navy text-copper px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.15em]">{p.badge}</span>}
        <span className="font-semibold">{p.title}</span>
        {p.body && <span className="hidden sm:inline text-navy/80">— {p.body}</span>}
        {p.cta_text && p.cta_url && (
          <Link to={p.cta_url} data-testid="promo-banner-cta" className="underline underline-offset-2 font-bold whitespace-nowrap hover:text-navy/70">{p.cta_text} →</Link>
        )}
      </div>
      <button data-testid="promo-banner-close" onClick={close} aria-label="Dismiss" className="absolute right-3 top-1/2 -translate-y-1/2 text-navy/70 hover:text-navy">
        <X size={16} />
      </button>
    </div>
  );
}
